// Lightweight inline SVG icon helper for DEV UI
// Returns a string of SVG markup for embedding in templates
// All icons use currentColor for stroke/fill so they inherit text color

const sizeAttr = (size) => `width="${size}" height="${size}"`;

export function icon(name, { size = 18, stroke = 2 } = {}) {
  switch (name) {
    case 'target':
      return `<svg ${sizeAttr(size)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="${stroke}"/>
        <circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="${stroke}"/>
      </svg>`;
    case 'compass':
      return `<svg ${sizeAttr(size)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="${stroke}"/>
        <path d="M10 14 L14 10 L10 10 L10 14 Z" fill="currentColor"/>
      </svg>`;
    case 'trending-up':
      return `<svg ${sizeAttr(size)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <polyline points="3,17 9,11 13,15 21,7" stroke="currentColor" stroke-width="${stroke}" fill="none"/>
        <polyline points="21,7 16,7 16,12" stroke="currentColor" stroke-width="${stroke}" fill="none"/>
      </svg>`;
    case 'grid':
      return `<svg ${sizeAttr(size)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="3" width="7" height="7" stroke="currentColor" stroke-width="${stroke}"/>
        <rect x="14" y="3" width="7" height="7" stroke="currentColor" stroke-width="${stroke}"/>
        <rect x="3" y="14" width="7" height="7" stroke="currentColor" stroke-width="${stroke}"/>
        <rect x="14" y="14" width="7" height="7" stroke="currentColor" stroke-width="${stroke}"/>
      </svg>`;
    case 'settings':
      // Simple sliders-style settings icon
      return `<svg ${sizeAttr(size)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="5" y1="6" x2="19" y2="6" stroke="currentColor" stroke-width="${stroke}"/>
        <circle cx="9" cy="6" r="2" fill="currentColor"/>
        <line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" stroke-width="${stroke}"/>
        <circle cx="15" cy="12" r="2" fill="currentColor"/>
        <line x1="5" y1="18" x2="19" y2="18" stroke="currentColor" stroke-width="${stroke}"/>
        <circle cx="11" cy="18" r="2" fill="currentColor"/>
      </svg>`;
    case 'message-square':
      return `<svg ${sizeAttr(size)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 4 H20 V16 H7 L4 19 V4 Z" stroke="currentColor" stroke-width="${stroke}" fill="none"/>
      </svg>`;
    case 'book':
      return `<svg ${sizeAttr(size)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 5 C4 4.447 4.447 4 5 4 H19 V18 H6 C4.895 18 4 18.895 4 20 V5 Z" stroke="currentColor" stroke-width="${stroke}" fill="none"/>
        <path d="M6 4 V18" stroke="currentColor" stroke-width="${stroke}"/>
      </svg>`;
    case 'trash':
      return `<svg ${sizeAttr(size)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 6 H21" stroke="currentColor" stroke-width="${stroke}"/>
        <path d="M8 6 V4 H16 V6" stroke="currentColor" stroke-width="${stroke}"/>
        <rect x="6" y="6" width="12" height="14" stroke="currentColor" stroke-width="${stroke}"/>
      </svg>`;
    case 'edit':
      return `<svg ${sizeAttr(size)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 20 L8 19 L19 8 L16 5 L5 16 L4 20 Z" stroke="currentColor" stroke-width="${stroke}" fill="none"/>
      </svg>`;
    case 'eye':
      return `<svg ${sizeAttr(size)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 12 C5 6 19 6 22 12 C19 18 5 18 2 12 Z" stroke="currentColor" stroke-width="${stroke}" fill="none"/>
        <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="${stroke}"/>
      </svg>`;
    case 'eye-off':
      return `<svg ${sizeAttr(size)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 12 C5 6 19 6 22 12 C19 18 5 18 2 12 Z" stroke="currentColor" stroke-width="${stroke}" fill="none"/>
        <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="${stroke}"/>
        <line x1="3" y1="3" x2="21" y2="21" stroke="currentColor" stroke-width="${stroke}"/>
      </svg>`;
    case 'rotate':
      return `<svg ${sizeAttr(size)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 12 A8 8 0 1 1 12 4 V2 L15 5 L12 8 V6" stroke="currentColor" stroke-width="${stroke}" fill="none"/>
      </svg>`;
    case 'broom':
      return `<svg ${sizeAttr(size)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 17 L9 11 L13 15 L7 21 L3 17 Z" stroke="currentColor" stroke-width="${stroke}" fill="none"/>
        <line x1="13" y1="15" x2="21" y2="7" stroke="currentColor" stroke-width="${stroke}"/>
      </svg>`;
    case 'alert-triangle':
      return `<svg ${sizeAttr(size)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 3 L2 20 H22 L12 3 Z" stroke="currentColor" stroke-width="${stroke}" fill="none"/>
        <line x1="12" y1="9" x2="12" y2="14" stroke="currentColor" stroke-width="${stroke}"/>
        <circle cx="12" cy="17" r="1" fill="currentColor"/>
      </svg>`;
    case 'key':
      return `<svg ${sizeAttr(size)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="7" cy="12" r="3" stroke="currentColor" stroke-width="${stroke}"/>
        <path d="M10 12 H21 M16 12 V9 M18.5 12 V10" stroke="currentColor" stroke-width="${stroke}"/>
      </svg>`;
    case 'user':
      return `<svg ${sizeAttr(size)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="8" r="3" stroke="currentColor" stroke-width="${stroke}"/>
        <path d="M4 20 C4 15 20 15 20 20" stroke="currentColor" stroke-width="${stroke}"/>
      </svg>`;
    case 'calendar':
      return `<svg ${sizeAttr(size)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="5" width="18" height="16" stroke="currentColor" stroke-width="${stroke}"/>
        <line x1="3" y1="9" x2="21" y2="9" stroke="currentColor" stroke-width="${stroke}"/>
        <line x1="8" y1="3" x2="8" y2="7" stroke="currentColor" stroke-width="${stroke}"/>
        <line x1="16" y1="3" x2="16" y2="7" stroke="currentColor" stroke-width="${stroke}"/>
      </svg>`;
    default:
      return '';
  }
}

export default { icon };

